module.exports = __webpack_public_path__ + "static/media/DECAT.baf30308.svg";